import Model, { AsyncBelongsTo, attr, belongsTo } from '@ember-data/model';

import type HotelModel from 'admin-panel/models/hotel';

export interface IntegrationCronJob {
  name: string;
  task: string;
  schedule?: string;
  [key: string]: unknown;
}

export interface IntegrationWebhook {
  name: string;
  enabled: boolean;
  [key: string]: unknown;
}

export interface IntegrationConfig {
  service: Record<string, unknown>;
  features: Record<string, unknown>;
  cron: IntegrationCronJob[];
  webhooks: IntegrationWebhook[];
  [key: string]: unknown;
}

export type IntegrationStackEnv = 'production' | 'staging';

export default class IntegrationsConfigurationModel extends Model {
  @belongsTo('hotel')
  declare hotel: AsyncBelongsTo<HotelModel>;

  @attr
  declare serviceName: string;

  @attr('boolean')
  declare enabled: boolean;

  @attr('string')
  declare integrationUuid: string;

  @attr('string')
  declare stackEnv: IntegrationStackEnv;

  @attr('number')
  declare version: number;

  @attr('string')
  declare hotelUuid: string;

  @attr('nested-object')
  declare currentConfig?: IntegrationConfig;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'integrations/configuration': IntegrationsConfigurationModel;
  }
}
